/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { UIState } from './interfaces';
import {
    UI_GOTO, UI_SET_CODE, CONFIG_GET_RECEIVE, CONFIG_GET_REQUEST, CONFIG_SEND_REQUEST, CONFIG_SEND_RECEIVE, CONFIG_STORE_REQUEST, CONFIG_STORE_RECEIVE, UI_SET_VAT, UI_SET_ACTIVE_PRODUCT, UI_SET_ACTIVE_LOGO_AREA, UI_SET_PREVIEW_ARTICLE_2, UI_SET_DETAIL_ARTICLE_INDEX, UI_SET_PREVIEW_ARTICLE_1, CONFIG_STORE_LOGO_REQUEST, CONFIG_STORE_LOGO_RECEIVE, UI_SET_COUNTRY, UI_SET_MOBILE_ORDER_STEP, UI_SET_EDIT_SCREEN_TAB, UI_SET_CUSTOM_BASE_COLOR, UI_SET_CUSTOM_CONTRAST_COLOR, UI_SHOW_COUNTRY_CHANGE_INFO
} from './actions';
import { isMobile } from 'react-device-detect';

export const initialState : UIState = {
    activeProduct: -1,
    activeLogoArea: -1,
    route: 'splashscreen',
    code: '',
    mobileOrderStep: 'order',
    editScreenTab: isMobile ? '' : 'colors',
    isLoadingConfig: false,
    loadingConfigError: null,
    isSendingConfig: false,
    sendingConfigError: null,
    isStoringConfig: false,
    storingConfigError: null,
    isStoringLogo: false,
    storingLogoError: null,
    vat: true,
    country: {
        id: 'de',
        currency: 'eur',
        vat: 0.19
    },
    showCountryChangeInfo: false,
    previewArticle1: '20',
    previewArticle2: '15',
    detailArticleIndex: isMobile ? 1 : 0,
    selectedTag: '',
    customBaseColor: null,
    customContrastColor: null
};

export default function ui(state: UIState = initialState, action : any) : UIState {
    switch (action.type) {
        case UI_GOTO:
            return Object.assign({}, state, {
                route: action.route
            })
        case UI_SET_CODE:
            return Object.assign({}, state, {
                code: action.code
            })
        case UI_SET_VAT:
            return Object.assign({}, state, {
                vat: action.vat
            })
        case UI_SET_COUNTRY:
            return Object.assign({}, state, {
                country: action.country
            })
        case UI_SHOW_COUNTRY_CHANGE_INFO:
            return Object.assign({}, state, {
                showCountryChangeInfo: action.showCountryChangeInfo
            })
        case UI_SET_ACTIVE_PRODUCT:
            return Object.assign({}, state, {
                activeProduct: action.activeProduct
            })
        case UI_SET_ACTIVE_LOGO_AREA:
            return Object.assign({}, state, {
                activeLogoArea: action.activeLogoArea
            })
        case UI_SET_MOBILE_ORDER_STEP:
            return Object.assign({}, state, {
                mobileOrderStep: action.mobileOrderStep
            })
        case UI_SET_EDIT_SCREEN_TAB:
            return Object.assign({}, state, {
                editScreenTab: action.editScreenTab
            })
        case UI_SET_PREVIEW_ARTICLE_1:
            return Object.assign({}, state, {
                previewArticle1: action.article
            })
        case UI_SET_PREVIEW_ARTICLE_2:
            return Object.assign({}, state, {
                previewArticle2: action.article
            })
        case UI_SET_DETAIL_ARTICLE_INDEX:
            return Object.assign({}, state, {
                detailArticleIndex: action.detailArticleIndex
            })
        case UI_SET_CUSTOM_BASE_COLOR:
            return Object.assign({}, state, {
                customBaseColor: action.customBaseColor
            })
        case UI_SET_CUSTOM_CONTRAST_COLOR:
            return Object.assign({}, state, {
                customContrastColor: action.customContrastColor
            })
        case CONFIG_GET_REQUEST:
            return Object.assign({}, state, {
                isLoadingConfig: true,
                loadingConfigError: null
            })
        case CONFIG_GET_RECEIVE:
            return Object.assign({}, state, {
                isLoadingConfig: false,
                loadingConfigError: action.fetchError,
                route: action.fetchError == null ? 'editscreen': state.route
            })
        case CONFIG_STORE_REQUEST:
            return Object.assign({}, state, {
                isStoringConfig: true,
                storingConfigError: null
            })
        case CONFIG_STORE_RECEIVE:
            return Object.assign({}, state, {
                code: action.code == null ? state.code : action.code,
                isStoringConfig: false,
                storingConfigError: action.fetchError
            })
        case CONFIG_SEND_REQUEST:
            return Object.assign({}, state, {
                isSendingConfig: true,
                sendingConfigError: null
            })
        case CONFIG_SEND_RECEIVE:
            return Object.assign({}, state, {
                isSendingConfig: false,
                sendingConfigError: action.fetchError,
                route: action.fetchError == null ? (isMobile ? 'editscreen' : 'postscreen'): state.route,
                mobileOrderStep: action.fetchError == null ? 'post': 'final',
            })
        case CONFIG_STORE_LOGO_REQUEST:
            return Object.assign({}, state, {
                isStoringLogo: true,
                storingLogoError: null
            })
        case CONFIG_STORE_LOGO_RECEIVE:
            return Object.assign({}, state, {
                isStoringLogo: false,
                storingLogoError: action.fetchError
            })
        default:
            return state;
    }
}
  
